import { useSelector } from '@redux';
import { Button, Select, Space } from 'antd';
import { useRestContext } from 'components/form/RestInputContext';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function CreateActions(
  {
    model,
    hasSelectFilter = true,
    customSubmit,
    customUrlBack,
  }: {
    model: string;
    hasSelectFilter?: boolean;
    customSubmit?: (form) => void;
    customUrlBack?: string;
  }
) {
  const { form } = useRestContext();
  const navigate = useNavigate();
  const loading = useSelector<boolean>((state) => state[model].createLoading);
  const onCancel = () => {
    if (customUrlBack) {
      navigate(customUrlBack);
    } else {
      navigate(-1);
    }
  }
  return (
    <Space>
      <Button disabled={loading} onClick={onCancel} className="btn-light btn-h-32">
        Cancel
      </Button>
      <Button loading={loading} onClick={customSubmit ? () => customSubmit(form) : () => form.submit()} type="primary" className='btn-h-32'>
        Create
      </Button>
      {hasSelectFilter && <Select placeholder="Select" options={[]} />}
    </Space>
  );
}
